package er.prateek.crossly.ui.screens.legal

import androidx.compose.foundation.layout.Box
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.ui.Modifier
import er.prateek.crossly.share.openExternalUrl

@Composable
actual fun WebViewContent(url: String, modifier: Modifier, onLoadingChanged: (Boolean) -> Unit) {
    LaunchedEffect(url) {
        openExternalUrl(url)
        onLoadingChanged(false)
    }
    Box(modifier = modifier)
}
